const acc = document.querySelectorAll('.js-acc')

for (const trigger of acc) {
  trigger.addEventListener(
    'click',
    function () {
      if (!trigger.classList.contains('active') && trigger.tagName !== 'A') {
        trigger.classList.add('active')
      } else {
        trigger.classList.remove('active')
      }
    },
    false
  )
}
